import styled from 'styled-components/macro';

const UserInfo = styled.div`
  width: calc(100% - 70px);
  margin-left: 15px;
`;

export default UserInfo;
